import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import SendBackToFix from '../../../widgets/sendToFix/SendBackToFix'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getReviewFeedback } from '../../../redux/actions/reviewerFeedback'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'

export default function SentToFix() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getReviewFeedback(proposalId)
      console.log('call api => ', JSON.stringify(_schema))

      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    //const projectId = '9BE3B891-FD65-416B-8459-7AD624B5D3F2'
    console.log('load ProposalRevise proposal', projectId)
    projectId && handleGetSchema(projectId)
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal statusDefault={7}>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          {schema?.forms?.agreementDetails && (
            <AgreementAdditionalWidgets
              showCommandButton={true}
              formSchema={schema.forms.agreementDetails}
            />
          )}

          {schema?.forms?.revise && (
            <SendBackToFix id={schema.projectReviewId} schema={schema.forms.revise} />
          )}

          <br />
        </SidebarProposal>
      )}
    </>
  )
}
